export enum FSEvents {
    GetHelpClicked = 'GetHelpClicked',
    SignInClicked = 'SignInClicked',
    SubmittedDot = 'SubmittedDot',
    CreateAccountFormSubmitted = 'CreateAccountFormSubmitted',
    CreateAccountBackButtonClicked = 'CreateAccountBackButtonClicked',
    VerifyingInfoBackButtonClicked = 'VerifyingInfoBackButtonClicked',
    VerifyingInfoSupportButtonClicked = 'VerifyingInfoSupportButtonClicked',
};

export interface BackButtonProperties {
    email: string;
};

export interface SubmittedDotProperties {
    dotNumber: number;
};

export interface CreateAccountProperties {
    chosenDotEmail: string;
    companyName: string;
    firstName: string;
    lastName: string;
    mcNumber: string;
};

